import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllEvenArchivedSubservices, getAllSubservicesGQL, getPublicSubServices, StateStatus } from '@guryou/redux';
const usePublicSubServices = _ref => {
  let {
    serviceId,
    subServiceId,
    all = true,
    archived = false
  } = _ref;
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity,
    request
  } = useSelector(state => state.subServices.active);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED || status === StateStatus.LOADED && (request === null || request === void 0 ? void 0 : request.serviceId) !== serviceId) {
      if (all) {
        dispatch(getPublicSubServices(serviceId, undefined, true));
      } else {
        if (archived) {
          dispatch(getAllEvenArchivedSubservices(serviceId));
        } else {
          dispatch(getAllSubservicesGQL(serviceId));
        }
      }
    }
  }, [all, archived, dispatch, request, serviceId, status]);
  if (!serviceId) {
    return {
      data: null,
      status: StateStatus.NOT_INITIALIZED
    };
  }
  if (subServiceId) {
    return data === null || data === void 0 ? void 0 : data.find(x => x.id === +subServiceId);
  }
  return {
    data: data || [],
    status,
    version,
    entity
  };
};
export default usePublicSubServices;